<script setup lang="ts">
  import { useI18n } from 'vue-i18n'
  import { useContentApi } from '@/composables/useCmsContentApi'
  import SubjectNavigation from '@/components/SubjectNavigation.vue'
  import Typography from '@/components/common/Typography.vue'
  import StandardLayout from '@/components/layout/Layout.vue'
  import { useQuery } from '@tanstack/vue-query'
  import VgsSpinner from '@/components/common/VgsSpinner.vue'
  import ImageWithCaption from '@/components/common/ImageWithCaption.vue'

  const { t } = useI18n()
  const { getAllSubjects } = useContentApi()

  const subjects = useQuery({
    queryKey: ['subjects'],
    queryFn: getAllSubjects,
    staleTime: Infinity
  })
</script>

<template>
  <StandardLayout>
    <div class="welcome-message">
      <div class="content">
        <div class="left">
          <typography variant="h1">
            {{ t('welcomeMessage.getToKnow') }}
          </typography>
          <typography variant="preamble">
            {{ t('welcomeMessage.trySubjects') }}
          </typography>
        </div>
        <div class="right">
          <ImageWithCaption
            alt-text="Bilde av fagbøker"
            aria-hidden="true"
            src="/forside_private.webp"
            copyright="Foto av Jmendez/istock photo, Klaus Vedfelt / Getty Images, Unsplash+ in collaboration with Getty Images, Nina Manandhar / Getty Images , gorodenkoff / istock photo, Mohamed hamdi / Unsplash+"
          />
        </div>
      </div>
    </div>

    <div class="subjects">
      <VgsSpinner :is-loading="subjects.isLoading.value" />

      <Typography
        variant="h3"
        component="h2"
      >
        {{ t('home.subjectTitle') }}
      </Typography>

      <SubjectNavigation
        v-if="subjects.data.value"
        :subjects="subjects.data.value"
      />
      <router-view />
    </div>
  </StandardLayout>
</template>

<style lang="scss" scoped>
  .welcome-message {
    background: var(--color-orange-20);
    color: var(--color-blue-50);
    padding: 146px 0 64px;
    margin-top: -82px;

    .content {
      max-width: var(--app-max-width);
      margin: 0 auto;
      height: 100%;
      display: flex;
      align-items: center;
      gap: 64px;
      padding: 0 24px;

      @include vgs-media-mobile-and-tablet {
        flex-direction: column;
      }

      .left,
      .right {
        flex: 1;

        @include vgs-media-desktop {
          width: 50%;
        }
      }

      .left {
        @include vgs-media-mobile {
          padding: 0;
        }
      }

      .right {
        flex: 1;

        img {
          max-width: 100%;
        }
      }
    }
  }

  .subjects {
    margin: 64px auto;
    max-width: var(--app-max-width);
    padding: 0 24px;
  }

  .byline-view {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4rem;
    background-color: white;
  }
</style>
